import type { MediaSummary } from "@/utils/media";
import { getDetailRoute, getTypeLabel } from "@/utils/media";

interface PosterCardProps {
  item: MediaSummary;
  progressLabel?: string;
  rank?: number;
}

export default function PosterCard({ item, progressLabel, rank }: PosterCardProps) {
  return (
    <a
      href={getDetailRoute(item.type, item.id)}
      className="group block cursor-pointer"
      title={`${item.title} - 天堂电影网`}
    >
      <div className="relative poster-ratio w-full overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200/70">
        <img
          src={item.poster}
          alt={`${item.title}海报`}
          title={`${item.title} - ${getTypeLabel(item.type)} - 天堂电影网`}
          className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent opacity-80" />
        <span className="absolute top-2 right-2 inline-flex items-center gap-0.5 rounded-md bg-background-50/80 px-1.5 py-0.5 text-xs font-semibold text-accent-300 backdrop-blur">
          <i className="ri-star-fill text-accent-400" aria-hidden="true" />
          {item.rating.toFixed(1)}
        </span>
        <span className="absolute top-2 left-2 rounded-md bg-primary-500/90 px-1.5 py-0.5 text-[10px] font-medium text-background-50">
          {getTypeLabel(item.type)}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-2.5 translate-y-2 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <span className="flex items-center justify-center gap-1 w-full rounded-md bg-accent-500 px-2 py-1.5 text-xs font-medium text-background-50">
            <i className="ri-play-fill" aria-hidden="true" />
            查看详情
          </span>
        </div>
        {rank !== undefined && (
          <span className="absolute bottom-2 left-2 inline-flex h-7 min-w-7 items-center justify-center rounded-md bg-foreground-950/90 px-1.5 font-heading text-sm font-bold text-background-50">
            {rank}
          </span>
        )}
        {progressLabel && (
          <span className="absolute bottom-2 left-2 rounded-md bg-accent-600/90 px-1.5 py-0.5 text-[10px] font-medium text-background-50">
            {progressLabel}
          </span>
        )}
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-accent-400 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
          {item.year} · {item.genres.slice(0, 2).join(" / ")}
        </p>
      </div>
    </a>
  );
}